"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbilityState = void 0;
class AbilityState {
    constructor(id, invokerId, args) {
        this.id = id;
        this.invokerId = invokerId;
        this.args = args;
    }
}
exports.AbilityState = AbilityState;
